import axios from "axios";
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { setAuthorization } from "../../../helpers/api_helper";
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';

const LOGIN_ENDPOINT = "/user/login";
const GOOGLE_LOGIN_ENDPOINT = "/auth/google";
const MICROSOFT_LOGIN_ENDPOINT = "/auth/microsoft";

export const loginUser = (user:any, history:any) => async (dispatch:any) => {

  try {
    const response = await axios.request({
      method: "post",
      url: LOGIN_ENDPOINT,
      data: {
        email: user.email,
        password: user.password,
      }
    });

    const data = (response && (response as any).data ? (response as any).data : response) as any;

    const token = data?.token;

    if (!token) {
      throw new Error("Login response did not include an access token");
    }

    sessionStorage.setItem("authUser", JSON.stringify(data));
    setAuthorization(token);
    dispatch(loginSuccess(data));
    history('/dashboard');
  } catch (error) {
    let message = "Unable to login. Please try again.";
    if (typeof error === 'string') {
      message = error;
    } else if (error && typeof error === 'object') {
      const axiosError = error as any;
      // Check for network errors (connection refused, timeout, etc.)
      if (axiosError?.code === 'ERR_NETWORK' || axiosError?.message?.includes('Network Error')) {
        message = "Cannot connect to server. Please check your connection and try again.";
      } else if (axiosError?.code === 'ECONNREFUSED' || axiosError?.message?.includes('ECONNREFUSED')) {
        message = "Server is not available. Please try again later.";
      } else {
        message = axiosError?.response?.data?.message || axiosError?.message || message;
      }
    }
    dispatch(apiError({ data: message }));
  }
};

export const logoutUser = () => async (dispatch:any) => {
  try {
    sessionStorage.removeItem("authUser");
    let fireBaseBackend :any= getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type:any, history:any) => async (dispatch:any) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend :any= getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }
      
      const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch:any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const googleLogin = (credential: string, history: any) => async (dispatch: any) => {
  try {
    const response = await axios.request({
      method: "post",
      url: GOOGLE_LOGIN_ENDPOINT,
      data: {
        credential: credential,
      }
    });

    const data = (response && (response as any).data ? (response as any).data : response) as any;

    const token = data?.token;

    if (!token) {
      throw new Error("Google login response did not include an access token");
    }

    sessionStorage.setItem("authUser", JSON.stringify(data));
    setAuthorization(token);
    dispatch(loginSuccess(data));
    history('/dashboard');
  } catch (error) {
    let message = "Unable to login with Google. Please try again.";
    if (typeof error === 'string') {
      message = error;
    } else if (error && typeof error === 'object') {
      const axiosError = error as any;
      // Check for network errors (connection refused, timeout, etc.)
      if (axiosError?.code === 'ERR_NETWORK' || axiosError?.message?.includes('Network Error')) {
        message = "Cannot connect to server. Please check your connection and try again.";
      } else if (axiosError?.code === 'ECONNREFUSED' || axiosError?.message?.includes('ECONNREFUSED')) {
        message = "Server is not available. Please try again later.";
      } else {
        message = axiosError?.response?.data?.message || axiosError?.message || message;
      }
    }
    dispatch(apiError({ data: message }));
  }
};

export const microsoftLogin = (microsoftData: any, history: any) => async (dispatch: any) => {
  try {
    const response = await axios.request({
      method: "post",
      url: MICROSOFT_LOGIN_ENDPOINT,
      data: {
        user: microsoftData.user,
        accessToken: microsoftData.accessToken,
        idToken: microsoftData.idToken,
        account: microsoftData.account,
      }
    });

    const data = (response && (response as any).data ? (response as any).data : response) as any;

    const token = data?.token;

    if (!token) {
      throw new Error("Microsoft login response did not include an access token");
    }

    sessionStorage.setItem("authUser", JSON.stringify(data));
    setAuthorization(token);
    dispatch(loginSuccess(data));
    history('/dashboard');
  } catch (error) {
    let message = "Unable to login with Microsoft. Please try again.";
    if (typeof error === 'string') {
      message = error;
    } else if (error && typeof error === 'object') {
      const axiosError = error as any;
      // Check for network errors (connection refused, timeout, etc.)
      if (axiosError?.code === 'ERR_NETWORK' || axiosError?.message?.includes('Network Error')) {
        message = "Cannot connect to server. Please check your connection and try again.";
      } else if (axiosError?.code === 'ECONNREFUSED' || axiosError?.message?.includes('ECONNREFUSED')) {
        message = "Server is not available. Please try again later.";
      } else {
        message = axiosError?.response?.data?.message || axiosError?.message || message;
      }
    }
    dispatch(apiError({ data: message }));
  }
};

export const githubLogin = (githubData: any, history: any) => async (dispatch: any) => {
  try {
    const response = await axios.request({
      method: "post",
      url: "/auth/github",
      data: {
        code: githubData.code,
        state: githubData.state,
      }
    });

    const data = (response && (response as any).data ? (response as any).data : response) as any;

    const token = data?.token;

    if (!token) {
      throw new Error("GitHub login response did not include an access token");
    }

    sessionStorage.setItem("authUser", JSON.stringify(data));
    setAuthorization(token);
    dispatch(loginSuccess(data));
    history('/dashboard');
  } catch (error) {
    let message = "Unable to login with GitHub. Please try again.";
    if (typeof error === 'string') {
      message = error;
    } else if (error && typeof error === 'object') {
      const axiosError = error as any;
      // Check for network errors (connection refused, timeout, etc.)
      if (axiosError?.code === 'ERR_NETWORK' || axiosError?.message?.includes('Network Error')) {
        message = "Cannot connect to server. Please check your connection and try again.";
      } else if (axiosError?.code === 'ECONNREFUSED' || axiosError?.message?.includes('ECONNREFUSED')) {
        message = "Server is not available. Please try again later.";
      } else {
        message = axiosError?.response?.data?.message || axiosError?.message || message;
      }
    }
    dispatch(apiError({ data: message }));
  }
};
